import { NumberInput } from '@mantine/core';
import classes from '../input.module.css';
import { defaultInputProps } from '../default-props';
export const numberInputProps = NumberInput.extend({
    classNames: classes,
    defaultProps: defaultInputProps,
});
